<template>
  <div class="main-ct">
    <div>
      <img
        src="@/img/gamification/xp-tb-deliver-the-right-game.png"
        :alt="$t('Gamification_Deliver_The_Right_Game_To_Every_Player')"
      />
    </div>
    <div class="description-ct">
      <p class="heading-paragraph">
        {{ $t('Gamification_Deliver_The_Right_Game_To_Every_Player') }}
      </p>
      <p class="description-paragraph">
        {{
          $t('Gamification_Deliver_The_Right_Game_Improve_Player_Engagement')
        }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GamificationDeliverTheRightGame'
}
</script>

<style scoped>
.main-ct {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 65px;
  gap: 40px;
  background-color: #fff;
}
.description-ct {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 350px;
}

.heading-paragraph {
  color: #5c6374;
  font-size: 24px;
  font-weight: 600;
  line-height: 30px;
}

.description-paragraph {
  color: #7e8596;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
}

img {
  width: 464px;
  height: 332px;
  object-fit: contain;
}
</style>



// WEBPACK FOOTER //
// src/modules/gamification/components/games-hub-upsell/GamificationDeliverTheRightGame.vue